<template>
	<div>

		<el-drawer :visible.sync="isshow" :with-header="false" :before-close="handleClose" :modal="ismodal" 
	
		>

			<div class="detailArea" v-loading="loading">


				<!--  -->
				<div class="detail-head FlexBetween outerpadd">
					<div class="head_left Flexalign">
						<div class="pup_title">
							{{ptitle}}
						</div>
						<template v-if="types == 1"> 
							<!-- 客户 -->
							<div class="detail_selChange Flexalign">
								<div class="sel_item Flexalign">
									<el-select v-model="screVal1" @change="setChanges($event, 1)">
										<el-option v-for="item in topselecto" :label="item.name" :value="item.id">
											{{ item.name }}
										</el-option>
									</el-select>
								</div>
								<div class="sel_item Flexalign">
									<el-select v-model="screVal2" @change="setChanges($event, 2)">
										<el-option v-for="item in topselectt" :label="item.name" :value="item.id">
											{{ item.name }}
										</el-option>
									</el-select>
								</div>
							</div>
						</template>
						

					</div>
					
					<div class="head_right Flexalign" >
						<template v-if="types == 1">
							<el-tooltip content="新建跟进" placement="bottom" effect="light">
								<el-button class="drawer_btn" icon="el-icon-edit" @click="head_btnClick(1)"></el-button>
							</el-tooltip>
							<el-tooltip content="新建商机" placement="bottom" effect="light">
								<el-button class="drawer_btn" icon="el-icon-suitcase" @click="head_btnClick(7)"></el-button>
							</el-tooltip>
							
						</template>
						<template v-else-if="types == 2">
							<el-tooltip content="转为客户" placement="bottom" effect="light">
								<el-button class="drawer_btn" icon="el-icon-edit" @click="head_btnClick(4)"></el-button>
							</el-tooltip>
							<el-tooltip content="分配客户" placement="bottom" effect="light">
								<el-button class="drawer_btn" icon="el-icon-suitcase" @click="head_btnClick(5)"></el-button>
							</el-tooltip>
						</template>
						<template v-else-if="types == 3">
							<el-tooltip content="转为客户" placement="bottom" effect="light">
								<el-button class="drawer_btn" icon="el-icon-edit" @click="head_btnClick(4)"></el-button>
							</el-tooltip>
						</template>
						<template v-else-if="types == 4">
							<el-tooltip content="领取线索" placement="bottom" effect="light">
								<el-button class="drawer_btn" icon="el-icon-edit" @click="head_btnClick(4)"></el-button>
							</el-tooltip>
							<el-tooltip content="分配线索" placement="bottom" effect="light">
								<el-button class="drawer_btn" icon="el-icon-suitcase" @click="head_btnClick(5)"></el-button>
							</el-tooltip>
						</template>
						
						<template v-if="types != 6">
							<el-tooltip content="编辑" placement="bottom" effect="light">
								<el-button class="drawer_btn" icon="el-icon-edit-outline" @click="head_btnClick(3)"></el-button>
							</el-tooltip>
						</template>
						
						<template v-if="types == 6">
							<el-tooltip content="新建跟进" placement="bottom" effect="light">
								<el-button class="drawer_btn" icon="el-icon-plus" @click="head_btnClick(1)"></el-button>
							</el-tooltip>
							<el-tooltip content="删除" placement="bottom" effect="light">
								<el-button class="drawer_btn" icon="el-icon-delete" @click="head_btnClick(6)"></el-button>
							</el-tooltip>
						</template>
						
						<el-dropdown v-if="types != 6" >
							<el-button type="text" class="drawer_btn-more" icon="el-icon-more" >
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<template v-if="types == 1">
									<!-- 客户 -->
									<el-dropdown-item :command="1"  @click.native="switchState(1)">
										添加联系人
									</el-dropdown-item>
									<el-dropdown-item :command="2"  @click.native="switchState(2)">
										转让客户
									</el-dropdown-item>
									<el-dropdown-item :command="3"  @click.native="switchState(3)">
										添加协同人
									</el-dropdown-item>
									<el-dropdown-item :command="4"  @click.native="switchState(4)">
										退回公海
									</el-dropdown-item>
								</template>
								<template v-else-if="types == 2 || types == 4 || types == 5">
									<!-- 公海 -->
									<el-dropdown-item :command="4"  @click.native="switchState(4)">
										删除
									</el-dropdown-item>
								</template>
								<template v-else-if="types == 3">
									<!-- 线索 -->
									<el-dropdown-item :command="2"  @click.native="switchState(2)">
										转让线索
									</el-dropdown-item>
									<el-dropdown-item :command="4"  @click.native="switchState(4)">
										退回公海
									</el-dropdown-item>
								</template>
								
							</el-dropdown-menu>
						</el-dropdown>
						
						<el-tooltip content="关闭" placement="bottom" effect="light" style="margin: 0;">
							<el-button class="drawer_btn" icon="el-icon-close" @click="handleClose"></el-button>
						</el-tooltip>
						
					
					</div>
					
				</div>
				<!--  -->
				<!--  -->
				<div class="detail-top Flexalign">
					
					<div class="detailhimg">
						<img :src="drawer_info.head_image" alt="" v-if="drawer_info.head_image">
						<img src="~assets/img/def_icon.png" v-else>
					</div>
					<div>
						<!--  -->
						<div class="isfatherArea Flexalign ">
							<div class="title_txt Flexalign">
								<div class="tit" v-show="!ischange">
									{{ drawer_info_title }} 
								</div>
							</div>
							<!-- <div class="title_change" v-show="ischange">
								<el-input ref="saveTagInput" v-model="drawer_info_title" @blur="titleBlur"></el-input>
							</div>
							<div class="change_btn" v-show="!ischange" @click="titleChnage">
								<i class="el-icon-edit-outline"></i>
							</div> -->
						</div>
						<!--  -->
						<!--  -->
						<div class="det_topinfo Flexalign">
							<div class="mem_txt" v-if="drawer_info.member_name">
								{{ drawer_info.member_name || "" }}
							</div>
							<div class="mem_txt" v-else-if="drawer_info.member">
								{{ drawer_info.member.name || "" }}
							</div>
							<div class="txts">
								创建于{{ drawer_info.create_time || "" }},
								{{ drawer_info.update_time ? '最近更新于'+ drawer_info.update_time : '暂无更新'}}
							</div>
						</div>
						<!--  -->
					</div>
				</div>
				<!--  -->
				<!--  -->
				<div class="detail_content " >
					<div class="container_tabs outerpadd">
						
						
						<!--  -->
						<el-tabs class="eltabs"  v-model="activeName">
							
							
							<el-tab-pane label="信息" name="1">
								
								<div class="eltabs_info FlexWrap">
									<div class="eltabs_item Flexalign" v-for="(item,index) in Information"
										v-if="item.field_type != 19"> 
										<div class="eltabs_label">{{ item.field }}</div> 
										<div class="eltabs_text Flexalign">
											<div class="member_area FlexRow" v-if="item.character">
												<i class="iconfont icon-a-lujing131"></i>
											</div>
											<div class="txt Singlerow" :title="item.select_field">
												{{ item.select_field || "暂无" }}
											</div>
										</div>
									</div>
								</div>
								
								<template v-if="types == 6">
									<followdetail :show="show_follow" 
									@refresh="updatesClose"
									ref="ref_follow"
									:detaill="drawer_info"></followdetail>
								</template>
								<template v-else>
									<detailsdisplay :classlist="curClass_list" :fieldlist="curField_list">
									</detailsdisplay>
								</template>
								
							</el-tab-pane>
						
							<!-- <el-tab-pane label="详细" name="2">
								
							</el-tab-pane> -->
							
							<el-tab-pane  name="3" 
							v-if="types == 1 || types == 3">
								<contactassoc :isshow="isshow" :types="log_types" 
								:memberlist="memberlist" :content_id="content_id" @retnum="(e)=> contact_num = e"
								:currentRote="1"></contactassoc>
								<template slot="label">
									<div class="b_navItem Flexalign" :class="{'isActive': activeName == '3'}">
										<span>
											联系人
										</span>
										<div class="num_box" v-if="contact_num">
											{{contact_num}}
										</div>
									</div>
								</template>
							</el-tab-pane>
							
							<el-tab-pane name="4" v-if="types < 5">
								<dynamics v-if="types == 1 || types == 2" :show="isshow" :customer_id="content_id"
								 @retnum="(e)=> dynam_num = e"
								></dynamics>
								<dynamics v-if="types == 3 || types == 4" :show="isshow" :cue_id="content_id"
								 @retnum="(e)=> dynam_num = e"
								></dynamics>
								<template slot="label">
									<div class="b_navItem Flexalign" :class="{'isActive': activeName == '4'}">
										<span>
											动态
										</span>
										<div class="num_box" v-if="dynam_num">
											{{dynam_num}}
										</div>
									</div>
								</template>
							</el-tab-pane>
							<template v-if="types == 1">
								<el-tab-pane  name="5" > 
									<assocmerging :types="1" :customer_id="content_id" :ishow="isshow" @closeDrawer="handleClose"
									@retnum="(e)=> projects_num = e"
									></assocmerging>
									<!--  -->
									<template slot="label">
										<div class="b_navItem Flexalign" :class="{'isActive': activeName == '5'}">
											<span>
												项目
											</span>
											<div class="num_box" v-if="projects_num">
												{{projects_num}}
											</div>
										</div>
									</template>
									<!--  -->
								</el-tab-pane>
							</template>
							
							<el-tab-pane name="6" 
							v-if="types == 1 || types == 2">
								<followupbox :show="isshow" :customer_id="content_id"
								@retnum="(e)=> follow_num = e"
								></followupbox>
								<!--  -->
								<template slot="label">
									<div class="b_navItem Flexalign" :class="{'isActive': activeName == '6'}">
										<span>
											跟进
										</span>
										<div class="num_box" v-if="follow_num">
											{{follow_num}}
										</div>
									</div>
								</template>
								<!--  -->
							</el-tab-pane>
							<!-- 客户关联项 -->
							
							<template v-if="types == 1">
								<el-tab-pane name="7" >
									<assocmerging :types="2" :customer_id="content_id" :ishow="isshow" @closeDrawer="handleClose"
									@retnum="(e)=> business_num = e" ref="merging2"
									></assocmerging>
									
									<!--  -->
									<template slot="label">
										<div class="b_navItem Flexalign" :class="{'isActive': activeName == '7'}">
											<span>
												商机
											</span>
											<div class="num_box" v-if="business_num">
												{{business_num}}
											</div>
										</div>
									</template>
									<!--  -->
								</el-tab-pane>
								<el-tab-pane name="8" >
									<assocmerging :types="3" :customer_id="content_id" :ishow="isshow" @closeDrawer="handleClose"
									@retnum="(e)=> quotation_num = e"
									></assocmerging>
									<!--  -->
									<template slot="label">
										<div class="b_navItem Flexalign" :class="{'isActive': activeName == '8'}">
											<span>
												报价单
											</span>
											<div class="num_box" v-if="quotation_num">
												{{quotation_num}}
											</div>
										</div>
									</template>
									<!--  -->
								</el-tab-pane>
								<el-tab-pane name="9" >
									<assocmerging :types="4" :customer_id="content_id" :ishow="isshow" @closeDrawer="handleClose"
									@retnum="(e)=> order_num = e"
									></assocmerging>
									<!--  -->
									<template slot="label">
										<div class="b_navItem Flexalign" :class="{'isActive': activeName == '9'}">
											<span>
												订单
											</span>
											<div class="num_box" v-if="order_num">
												{{order_num}}
											</div>
										</div>
									</template>
									<!--  -->
								</el-tab-pane>
								<el-tab-pane name="10" >
									<assocmerging :types="5" :customer_id="content_id" :ishow="isshow" @closeDrawer="handleClose"
									@retnum="(e)=> contract_num = e"
									></assocmerging>
									<!--  -->
									<template slot="label">
										<div class="b_navItem Flexalign" :class="{'isActive': activeName == '10'}">
											<span>
												合同
											</span>
											<div class="num_box" v-if="contract_num">
												{{contract_num}}
											</div>
										</div>
									</template>
									<!--  -->
								</el-tab-pane>
								<el-tab-pane name="11" >
									<assocmerging :types="6" :customer_id="content_id" :ishow="isshow" @closeDrawer="handleClose"
									@retnum="(e)=> collection_num = e"
									></assocmerging>
									<!--  -->
									<template slot="label">
										<div class="b_navItem Flexalign" :class="{'isActive': activeName == '11'}">
											<span>
												回款
											</span>
											<div class="num_box" v-if="collection_num">
												{{collection_num}}
											</div>
										</div>
									</template>
									<!--  -->
								</el-tab-pane>
							</template>
						</el-tabs>
						<!--  -->
					</div>
					<!--  -->
					<div class="content-container_bottom">
						<div class="container_bottom_tabs">
							<el-tabs class="bottom_eltabs" v-model="activeLog">
								<!-- :label="operalog_num ? `操作日志(${operalog_num})` : '操作日志'" -->
								<el-tab-pane  name="5">
									<operationlog :show="islogshow" :types="log_types" :content_id="content_id"
									@retnum="(e)=> operalog_num = e">
									</operationlog>
									<!--  -->
									<template slot="label">
										<div class="b_navItem FlexRow" :class="{'isActive': activeLog == '5'}">
											<span>
												操作日志
											</span>
											<div class="num_box" v-if="operalog_num">
												{{operalog_num}}
											</div>
										</div>
									</template>
									<!--  -->
								</el-tab-pane>
								<el-tab-pane>
								</el-tab-pane>
							</el-tabs>
						</div>
					</div>
					<!--  -->

				</div>
				<!--  -->
				
			</div>
			
			<div class="pupclose FlexColumn" @click="handleClose">
				<i class="el-icon-arrow-right"></i>
			</div>
		</el-drawer>


	</div>
</template>
<script>
	import {
		fn_retjson,
		retJSONArr,
		retableSort ,
	} from "network/defaults";
	// 详情信息 
	import detailsdisplay from "./detailsdisplay.vue"
	// 操作日志
	import operationlog from "@/components/tabledata/operationlog.vue";
	// 关联联系人
	import contactassoc from "../association/contactassoc.vue"
	// 跟进显示
	import followupbox from "components/content/addproduct/followupbox";
	// 动态显示
	import dynamics from "components/content/addproduct/dynamics";
	// 跟进信息
	import followdetail from "../followdetail.vue"
	
	
	// 关联合并项
	import assocmerging from "@/components/association/assocmerging.vue";
	
	import {
		timestampToTime,
	} from "network/kh_public";
	import {
		editCustomer2,
	} from "network/hk_customer";
	export default {
		name: "detailspup",
		components: {
			assocmerging,
			
			detailsdisplay,
			operationlog,
			contactassoc,
			followupbox,
			dynamics,
			followdetail,
			
		},
		props: {
			ptitle: {
				type: String,
				default: '',
			},
			dinfo: {  // 当前详情所有信息 字符串
				type: String,
				default: '',
			},
			stablelist: {  // 信息区域字段列表
				type: Array,
				default: () => {
					return []
				},
			},
			topselecto: { // 顶部下拉选项列表第1个 
				type: Array,
				default: () => {
					return []
				},
			},
			topselectt: { // 顶部下拉选项列表第2个
				type: Array,
				default: () => {
					return []
				},
			},
			// 推出类型 1 客户, 2 客户公海， 3 线索， 
			// 4 线索公海， 5:联系人  6：跟进记录  7：跟进计划
			types: { 
				type: Number,
				default: 1,
			},
			classlist: {  // 字段分类列表
				type: Array,
				default: () => {
					return [];
				},
			},
			fieldlist: { // 字段列表
				type: Array,
				default: () => {
					return [];
				},
			},
			memberlist: {  // 成员列表
				type: Array,
				default: () => {
					return [];
				},
			},
			content_id: {  // 当前详情id
				type: Number,
				default: 0,
			},
			isshow: {  // 推出显示隐藏
				type: Boolean,
				default: false,
			},
			loading: { // 基础数据 是否加载完成
				type: Boolean,
				default: true,
			},
			ismodal: { // 黑布
				type: Boolean,
				default: false,
			},
			
		},
		data() {
			return {
				show_follow: false,
				// 
				contact_num: 0,
				dynam_num: 0,
				projects_num: 0,
				follow_num: 0,
				business_num: 0,
				quotation_num: 0,
				order_num: 0,
				contract_num: 0,
				collection_num: 0,
				operalog_num: 0,
				// 
				
				screVal1: 0,  // 顶部下拉框 选定值
				screVal2: 0,  // 顶部下拉框 选定值
				drawer_info: '',  // 当前所有详情信息
				activeName: '1',  // 内容显示
				activeLog: "5",  // 操作日志区域显示
				windowHeight: window.innerHeight,  // 窗口高度
				curClass_list: [],	// 详细区域 字段分类
				curField_list: [],  // 详细区域 字段列表
				Information: [],  // 信息区域 内容
				log_types: 1,  // 操作日志类型
				islogshow: false,  // 操作日志
				drawer_info_title: '',  // 当前推出主标题
				// 标题修改
				currentTitle: '',
				ischange: false,
			};
		},
		watch: {
			isshow() {
			
				this.activeName = '1'
				this.islogshow = false
				this.show_follow = false
				if (this.isshow) {
					this.setDatas()
				} else {
					this.drawer_info = ''
				}
			},
			dinfo() {
				this.islogshow = false
				this.show_follow = false
				if (this.dinfo) {
					this.setDatas()
					this.setlists()
				} else {
					this.drawer_info = ''
					this.clearNum()
				}
			},
			fieldlist(){
				this.setlists()
			},
		},
		methods: {
			RefreshAssocia(){
				if(this.$refs.merging2) {
					this.$refs.merging2.Refresh()
				}
			},
			clearNum(){
				this.contact_num = 0
				this.dynam_num = 0
				this.projects_num = 0
				this.follow_num = 0
				this.business_num = 0
				this.quotation_num = 0
				this.order_num = 0
				this.contract_num = 0
				this.collection_num = 0
				this.operalog_num = 0
			},
			// 设置信息和详情
			setlists(){
				let newArr1 = this.headledata(this.fieldlist)
				this.curField_list = fn_retjson(newArr1)
				let newArr2 = this.headledata(this.stablelist)
				this.Information = fn_retjson(newArr2.sort(retableSort))
			},
			// 处理信息数据
			headledata(arr) {
				if (arr.length) {
					for (let item of arr) {
						item.disabled = true
						let field_type = item.field_type
						let field = item.field || item.field_sign;
						if (field_type == 3 && item.select_field) { // 时间字段 时间戳转时间文字
							item.select_field = timestampToTime(item.select_field, true)
						}
						if (field == '协同人') {
							if (this.memberlist.length && item.content.length) {
								let res_arr = []
								for (let val of item.content) {
									let arr1 = this.memberlist.filter(v => v.member_id == val)
									let name = arr1[0] ? arr1[0].name : '';
									res_arr.push(name)
								}
								item.select_field = res_arr.length ? res_arr.join('、') : '';

							} else {
								item.select_field = ''
							}
						}
					}
				}
				return arr
			},
			// 设置大体数据 detaill
			setDatas() {
				let res = retJSONArr(this.dinfo)
				
				// 
				if(this.types == 6) {
					setTimeout(()=>{
						this.show_follow = true
					}, 500)
				}
				this.drawer_info = fn_retjson(res)
				this.drawer_info_title = this.drawer_info.name || this.drawer_info.customer_name;
				this.islogshow = false
				this.currentTitle = fn_retjson(this.drawer_info_title)
				if(this.types == 1 && this.drawer_info) {  // 客户
					let {
						state, follow_id, follow_up_stage,
					} = this.drawer_info
					// 客户状态
					this.screVal1 = state * 1
					// 客户阶段
					this.screVal2 = follow_id * 1
				}
				setTimeout(() => {
					this.islogshow = true
				}, 350)
				// 字段分类
				this.curClass_list = fn_retjson(this.classlist)
				if(this.types < 3) {   // 客户，公海客户
					this.log_types = 2
				}
				else if(this.types > 3 && this.types < 5) {   // 线索，线索客户
					this.log_types = 1
				}
				else if(this.types == 5) {  //  联系人
					this.log_types = 3
				}
				else if(this.types == 6) {  // 跟进
					this.log_types = 4
				}
			},
			// 关闭推出
			handleClose() {
				this.$emit("update:isshow", false);
			},
			// 关闭推出并刷新列表数据
			updatesClose() {
				this.$emit("updatesClose");
			},
			// 刷新当前推出内容
			fnupdatedet(){
				this.$emit('update')
			},
			// 推出按钮点击
			head_btnClick(flag) {
				this.$emit('btnClick', {flag})
			},
			// 推出下拉按钮点击
			switchState(flag) {
				if(flag == 1) {
					this.activeName = '3'
				}
				else {
					this.$emit('switchState', {flag})
				}
			},
			// 修改状态
			setChanges(e, flag) {
				let data = {
					customer_id: this.drawer_info ? this.drawer_info.customer_id : '',
				}
				if(flag == 1) {
					data.state = e
				}
				else if(flag == 2) {
					data.follow_id = e
				}
				this.editCustSelect(data)
			},
			// 更改客户
			editCustSelect(data) {
				editCustomer2(data).then(res => {
					if (this.$handlereq(res)) {
						this.$alertMess("更新成功", "success");
						this.fnupdatedet()
					}
				})
			},
			// 修改标题
			// titleBlur() {
			// 	let val = (this.drawer_info_title + '').trim()
			// 	if (val) {
			// 		if(this.currentTitle != val) {
						
			// 		}
			// 		this.ischange = false
			// 	} 
			// 	else {
			// 		this.$alertMess('标题不能为空', 'error')
			// 	}
			// },
			// titleChnage() {
			// 	if (this.$refs.saveTagInput) {
			// 		this.ischange = true
			// 		this.$nextTick(() => this.$refs.saveTagInput.focus());
			// 	}
			// },
		},
	};
</script>
<style scoped lang="scss">
	@import "@/assets/css/project/dpup.scss";
	// /deep/ .el-drawer.rtl {
	// 	width: 1000px !important;
	// }
</style>